<a
  class="flex items-center webform-field--webform_link border-t border-b border-border hover:border-border"
  [href]="url"
  target="_blank"
>
  <span>
    {{ title }}
  </span>
  <mobi-ui-icon-major class="ml-auto mr-0" [name]="icon" />
</a>
